export default __webpack_public_path__ + "static/media/nuclear-powerplant.d71f4c1c.svg";